import { render, staticRenderFns } from "./AlleleFrequencyExport.vue?vue&type=template&id=d6d957f4&"
import script from "./AlleleFrequencyExport.vue?vue&type=script&lang=js&"
export * from "./AlleleFrequencyExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports